// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e2baedf6","239":"b7c375fd","455":"8a94cf22"}[chunkId] + ".chunk.js";
};